import { createFileRoute } from "@tanstack/react-router"

import { TeamPage } from "./-TeamPage"

export const Route = createFileRoute("/team/")({
  component: TeamPage,
})
